<template>
  <div class="navigation" v-if="numQuestion !== -1 && numQuestion !== questions.length">
    <div class="columns">
      <div class="question-number column" :title="$t('question_number')">
        <div class="question-number">
          {{ numQuestion + 1 }} {{ $t('of') }} {{ questions.length }}
        </div>
      </div>
      <div class="quiz-progress">
        <div class="current" :style="{width: progress+'%'}"></div>
      </div>
      <div v-show="Boolean(quiz.duration) && !resolveResolution" :title="$t('time_left')"
           class="quiz-time-left column col-6 text-right">
        <i class="fa fa-time"></i> {{ timerText }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'navigation',
  props: ['numQuestion', 'questions', 'quiz', 'resolveResolution', 'timerText'],
  computed: {
    progress() {
      return this.numQuestion / this.questions.length * 100;
    },
  },
};
</script>

<style scoped>
.navigation {
  margin-bottom: 10px;
  font-size: 0.7em;
}

.navigation .columns {
  padding: 0 5px;
  margin-right:0;
  align-items: center;
}

.question-number {
  padding-right: 3vw;
  flex-grow: 0;
  white-space: nowrap;
  font-size: 16px;
  font-weight: 600;
  color: var(--color-project-secondary);
  opacity: .9;
}
.quiz-progress {
  flex-grow: 1;
  height: 20px;
  background: var(--color-project-light-gray);
  border-radius: 100px;
  /*overflow: hidden;*/
}
.quiz-progress .current {
  min-width: 10px;
  background: var(--color-project-gradient-from);
  height: 20px;
  position: relative;
  transition: all ease-in-out .15s;
  border-radius: 100px;
  z-index: 2;
}
.quiz-progress .current::after {
  content: '';
  display: block;
  width: 26px;
  height: 26px;
  background: var(--color-project-primary);
  position: absolute;
  right: -10px;
  top: -3px;
  border-radius: 900px;
  z-index: -1;
}
/*.quiz-progress .current::after {*/
/*  content: '';*/
/*  display: block;*/
/*  position: absolute;*/
/*  right: 0px;*/
/*  transform: translateX(100%);*/
/*  width: 0;*/
/*  height: 0;*/
/*  border-top: 10px solid transparent;*/
/*  border-bottom: 10px solid transparent;*/
/*  border-left: 10px solid var(--color-system-secondary);*/
/*}*/
</style>
